module.exports = __webpack_public_path__ + "static/media/super_pack_en_chien_hiver.c9524b36.png";